export const OPEN_QUALITY_PICKER = 'character/OPEN_QUALITY_PICKER';
export const CLOSE_QUALITY_PICKER = 'character/CLOSE_QUALITY_PICKER';